/* eslint-disable */
/**
 * SPA
 * API serving data for the SPA
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * The type of the sequence
 * @export
 */
export const PlasmidViewSequenceTypeConstants = {
    dna: 'dna',
    rna: 'rna'
} as const;
export type PlasmidViewSequenceTypeConstants = typeof PlasmidViewSequenceTypeConstants[keyof typeof PlasmidViewSequenceTypeConstants];


export function PlasmidViewSequenceTypeConstantsFromJSON(json: any): PlasmidViewSequenceTypeConstants {
    return PlasmidViewSequenceTypeConstantsFromJSONTyped(json, false);
}

export function PlasmidViewSequenceTypeConstantsFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlasmidViewSequenceTypeConstants {
    return json as PlasmidViewSequenceTypeConstants;
}

export function PlasmidViewSequenceTypeConstantsToJSON(value?: PlasmidViewSequenceTypeConstants | null): any {
    return value as any;
}

